// en.js
module.exports = {
    "column": {
        "home": "Homepage",
        "gallery": "Local Tour",
        "blog": "Local activities",
        "menu": "Pay of activities",
        "about": "About Pataw",
        "news":"News",
        "how": "How to come to Keelung",
        "getNews" :"Subscribe to Keelung newsletter",
        "subscribe": "Follow us",
        "findUs": "Coonect with us"
      },
      "text": {
        "search": "Search"
      },
      "about":{
          "name":"Keelung Backpacker Pataw Hostal",
          "describe":"The Pataw Hostal International Backpacker Life Experience Museum is hidden on the most beautiful coastline in Keelung and is in harmony with the local fishing village. \nI want to see the witches living on the most beautiful coasts? Let us continue to watch...",
          "about":"About Pataw"
      },
      "footer":{
          "found_us":"Find Us",
          "address":"No.21, Ln. 369, Beining Rd. , Zhongzheng Dist. , Keelung City, Taiwan",
          "news":"News",
          "event":"                The most embarrassing way to play this year is to come to Keelung to participate in the Fairy Tale Festival\n********************************** \nWe have a large balloon in the Ocean Plaza, Yangming Marine Culture and Art Museum, Civic Square, Cultural Square, a colorful market, a fantastic gift box, a brilliant show, a paper windmill, and a double-decker bus. nThe brothers and sisters of the YOYO family\n**********************************\nWelcome to the public Mom took her children to Keelung\n to participate in the 2019 Keelung Fairy Tale Art Festival to knock down Keelung\n",
          "detail":"Detail"
    },
    "hello": {
      "welcome1": "Welcome to ",
      "welcome2": "KEELUNG",
    }
    }


//////////////////
// WEBPACK FOOTER
// ./static/lang/en.js
// module id = AQny
// module chunks = 1